import React, { useEffect, useState } from "react";
import "./PartnerLogos.css";

// Loga firm, z którymi współpracuje Ekselowe.pl — Tomasz zarządza nimi
// samodzielnie w panelu (Dashboard -> Zarządzaj Logami Partnerów).
const PartnerLogos = () => {
  const [partners, setPartners] = useState(null); // null = ładowanie

  useEffect(() => {
    fetch("https://ekselowe.pl/api/getpartners.php", {
      headers: { "Content-Type": "application/json; charset=UTF-8" },
    })
      .then((response) => response.json())
      .then((json) => {
        const keys = Object.keys(json || {});
        setPartners(keys.map((key) => ({ id: key, ...json[key] })).filter((p) => p.image));
      })
      .catch(() => setPartners([]));
  }, []);

  if (!partners || partners.length === 0) {
    return null;
  }

  const renderLogo = (partner, key) =>
    partner.link ? (
      <a
        className="partner-logo-slot"
        key={key}
        href={partner.link}
        target="_blank"
        rel="noopener noreferrer"
        title={partner.name || ""}
      >
        <img src={partner.image} alt={partner.name || ""} />
      </a>
    ) : (
      <div className="partner-logo-slot" key={key} title={partner.name || ""}>
        <img src={partner.image} alt={partner.name || ""} />
      </div>
    );

  // Do 5 logo — spokojna, statyczna siatka. Powyżej 5 — płynnie
  // przewijający się pasek (widget), żeby wszystkie logo były widoczne
  // bez rozjeżdżania się układu na wiele rzędów.
  const useCarousel = partners.length > 5;
  const duration = Math.max(18, partners.length * 4);

  return (
    <div className="partner-logos-panel" id="partner-logos-id">
      <div className="partner-logos-container">
        <p className="title">zaufali nam</p>
        <p className="subtitle-dark">Firmy, z którymi współpracujemy</p>
        {useCarousel ? (
          <div className="partner-logos-marquee">
            <div
              className="partner-logos-track"
              style={{ animationDuration: `${duration}s` }}
            >
              {[...partners, ...partners].map((partner, i) => renderLogo(partner, `${partner.id}-${i}`))}
            </div>
          </div>
        ) : (
          <div className="partner-logos-grid">
            {partners.map((partner) => renderLogo(partner, partner.id))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnerLogos;
